// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/HotTopic/EditHotTopic/index.css
// module id = 945
// module chunks = 0